import { handleActions } from 'redux-actions'
import { ActivitiesType } from '@tabeeb/contracts/main-api/swagger-main-api'
import * as galleryActions from '../actions'
import { DisplayPage } from '../enums'

const defaultState = {
  displayPage: DisplayPage.All,
  userId: 'all',
  activityType: ActivitiesType.All,
  searchFilter: '',
}

const activitiesFilter = handleActions(
  {
    [galleryActions.setPageFilter](state, action) {
      return { ...state, displayPage: action.payload }
    },
    [galleryActions.setUserFilter](state, action) {
      return { ...state, userId: action.payload }
    },
    [galleryActions.setActivityTypeFilter](state, action) {
      return { ...state, activityType: action.payload }
    },
    [galleryActions.onEnterSearchTextFilter](state, action) {
      return { ...state, searchFilter: action.payload }
    },
    [galleryActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)

export default activitiesFilter
